import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ForumService } from '@fi-app/forum/forum.service';
import { WidgetSettingsControlBase } from '../control-base';
import { ForumModel } from '@fi-app/forum/forum.model';

@Component({
    selector: 'widget-settings-control-forum-feed',
    templateUrl: './forum-feed.component.html',
    styleUrls: ['./forum-feed.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'widget-settings-control-forum-feed' },
    standalone: false,
})
export class WidgetSettingsControlForumFeedComponent extends WidgetSettingsControlBase implements OnInit {
    forumsListData = new DropdownSettingsModelV2();

    constructor(
        injector: Injector,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private forumService: ForumService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.setForumListData();
    }

    private setForumListData() {
        if (
            this.accessToApplicationTypeService.HasAccessToApplicationType(
                ApplicationSettingsType.Forum,
                AccessRightType.Share,
            )
        ) {
            this.forumService.getForumsForWidget(false).then((data: ForumModel[]) => {
                this.forumsListData.setDataSet(data);
            });
        }
    }

    onNumberOfRecordsToTakeChanged($event: number) {
        this.Settings.NumberOfRecordsToTake = $event;
        this.settingsOnChange();
    }
}
